/**
 * Combination.ts
 */
export class Combination {
    constructor(n, r) {
        this.n = n;
        this.r = r;
        this.index = [];
        for (let i = 0; i < r; i++) {
            this.index[i] = i;
        }
        this._hasNext = true;
    }
    hasNext() {
        return this._hasNext;
    }
    moveIndex() {
        let i = this.rightMostIndexBelowMax();
        if (i >= 0) {
            this.index[i] = this.index[i] + 1;
            for (let j = i + 1; j < this.r; j++) {
                this.index[j] = this.index[j - 1] + 1;
            }
        }
        else {
            this._hasNext = false;
        }
    }
    next() {
        let result = [];
        for (let i = 0; i < this.r; i++) {
            result[i] = this.index[i];
        }
        this.moveIndex();
        return result;
    }
    rightMostIndexBelowMax() {
        for (let i = this.r - 1; i >= 0; i--) {
            if (this.index[i] < this.n - this.r + i) {
                return i;
            }
        }
        return -1;
    }
}
//# sourceMappingURL=Combination.js.map